import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../../../src/helpers/reselectHelpers';
import {makeGetContactsManagerParameters} from '../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {ContactsManagerParametersTypesEnum} from '../../../../../../../src/store/panels/contacts/contactsManager/parameters/contactsManagerParameters';
import {ContactsManagerPanelId} from '../../../../../../../src/store/panels/panelStateBase';
import {navigateToLinkAction} from '../../../../../../../src/store/stateless/navigationActions';
import {ContactsManagerSearchBar} from './contactsManagerSearchBar';

/*
 * Props.
 */

interface ContactsManagerSearchBarContainerProps {
  panelId: ContactsManagerPanelId;
}

/*
 * Selectors.
 */

function makeGetContactsManagerSearchQuery() {
  return createSelector([makeGetContactsManagerParameters()], (params) => {
    if (params.type !== ContactsManagerParametersTypesEnum.SEARCH) {
      return '';
    }
    return params.query;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ContactsManagerSearchBarContainerProps>()(() => ({
  query: makeGetContactsManagerSearchQuery(),
  parameters: makeGetContactsManagerParameters(),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  navigateToLink: navigateToLinkAction,
}));

export const ContactsManagerSearchBarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactsManagerSearchBar);
